export enum AnimationTypes {
    FADE_IN = "animated fadeInLeft",
    FADE_OUT = "animated fadeOutLeft",
    FADE_IN_NORMAL = "animated fadeIn",
    FADE_OUT_NORMAL = "animated fadeOut"
}